// extracted by mini-css-extract-plugin
module.exports = {"typing":"TypingIndicator_typing__tshew","flash":"TypingIndicator_flash__QfUQC"};